var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "token",
    class: [_vm.isMobile && 'wap', _vm.isDetailLoading && 'empty']
  }, [_c('p-head'), _c('div', {
    staticClass: "token-main main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "token-transaction"
  }, [_c('m-transaction')], 1), _c('div', {
    staticClass: "token-body"
  }, [_c('div', {
    staticClass: "token-head",
    style: {
      height: _vm.isMobile ? _vm.remTran((_vm.isPhone ? 130 : 340) + _vm.mobileHeadHeight) : ''
    }
  }, [_c('div', {
    staticClass: "token-img"
  }, [!_vm.isDetailLoading ? [_vm.detail && _vm.detail.icon ? _c('img', {
    attrs: {
      "src": _vm.detail.icon,
      "alt": ""
    }
  }) : _vm._e()] : _vm._e(), _vm.isDetailLoading || _vm.detail && !_vm.detail.icon ? _c('m-img-empty') : _vm._e()], 2), _c('div', {
    staticClass: "token-basic"
  }, [_c('div', {
    staticClass: "token__title"
  }, [_c('em', {
    style: {
      maxWidth: !_vm.isMobile && (_vm.htmlSize.w < 1364 && _vm.htmlSize.w > 1200 && _vm.remTran(250) || _vm.htmlSize.w < 1200 && _vm.remTran(200))
    },
    attrs: {
      "title": _vm.detail ? _vm.detail.name : ''
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.detail.name : ""))]), _vm._v(" "), _vm.detail && _vm.detail.symbol ? _c('i', [_vm._v("(" + _vm._s(_vm.detail.symbol) + ")")]) : _vm._e()]), _c('div', {
    staticClass: "token__address",
    attrs: {
      "title": _vm.detail && _vm.detail.address
    }
  }, [_vm.detail ? _c('span', {
    staticClass: "hover",
    on: {
      "click": function ($event) {
        return _vm.onCopy(_vm.detail.address);
      }
    }
  }, [_vm._v(" " + _vm._s(!_vm.isMobile ? _vm.fmt_addr(_vm.detail.address, 10) : _vm.fmt_addr(_vm.detail.address, 12)) + " ")]) : _vm._e(), _c('i', {
    staticClass: "hover",
    on: {
      "click": function ($event) {
        _vm.detail && _vm.onSkip(_vm.detail.address, 'token');
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-share"
    }
  })], 1)]), _c('div', {
    staticClass: "token-share"
  }, [_vm.detail && _vm.detail.twitter ? _c('div', {
    staticClass: "token-share-item hover",
    attrs: {
      "title": _vm.detail && _vm.detail.twitter
    },
    on: {
      "click": function ($event) {
        _vm.detail && _vm.onShare(_vm.detail.twitter);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1) : _vm._e(), _vm.detail && _vm.detail.telegram ? _c('div', {
    staticClass: "token-share-item hover",
    attrs: {
      "title": _vm.detail && _vm.detail.telegram
    },
    on: {
      "click": function ($event) {
        _vm.detail && _vm.onShare(_vm.detail.telegram);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "telegram"
    }
  })], 1) : _vm._e(), _vm.detail && _vm.detail.website ? _c('div', {
    staticClass: "token-share-item hover",
    attrs: {
      "title": _vm.detail && _vm.detail.website
    },
    on: {
      "click": function ($event) {
        _vm.detail && _vm.onShare(_vm.detail.website);
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "explorer"
    }
  })], 1) : _vm._e(), _vm.isMobile ? _c('div', {
    staticClass: "btn-share hover",
    on: {
      "click": _vm.onShareEarn
    }
  }, [_vm._v("Share & Earn")]) : _vm._e()])]), _vm.descriptionText ? _c('div', {
    staticClass: "token-intro"
  }, [_c('span', {
    ref: "tokenIntroRef"
  }, [_vm._v(_vm._s(_vm.descriptionText) + " ")]), _vm.descriptionText ? _c('em', {
    staticClass: "btn",
    on: {
      "click": _vm.onToggleDescriptionExpand
    }
  }, [_vm.detail.description.length > this.descriptionMaxLength ? [_vm._v(" " + _vm._s(!_vm.isDescriptionExpanded ? "Read more" : "Hide") + " ")] : _vm._e()], 2) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "token-user"
  }, [_c('span', [_c('i', [_vm._v("Creator:")]), _c('em', {
    attrs: {
      "title": _vm.detail && _vm.detail.creator
    }
  }, [_c('i', {
    staticClass: "hover",
    on: {
      "click": function ($event) {
        _vm.detail && _vm.onCopy(_vm.detail.creator);
      }
    }
  }, [_vm._v(_vm._s(_vm.detail ? _vm.fmt_addr(_vm.detail.creator, 8) : ""))]), _vm._v(" "), _c('i', {
    staticClass: "hover",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.detail ? _vm.onSkip(_vm.detail.creator, 'address') : '';
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-share"
    }
  })], 1)])]), _c('span', [_c('i', [_vm._v("Created: ")]), _vm.detail ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_cd")(_vm.nowTime - _vm.detail.created_time)) + " ago")]) : _vm._e()]), !_vm.isMobile ? _c('div', {
    staticClass: "btn-share hover",
    on: {
      "click": _vm.onShareEarn
    }
  }, [_vm._v("Share & Earn")]) : _vm._e()])]), _c('div', {
    staticClass: "token-chart"
  }, [_c('div', {
    staticClass: "chart-tab"
  }, _vm._l(['1m', '5m', '15m', '1h', '4h', '1d'], function (item, index) {
    return _c('div', {
      staticClass: "chart-tab-item hover",
      class: _vm.kLineParams.type === item && 'active',
      on: {
        "click": function ($event) {
          return _vm.onChartTab(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item))])]);
  }), 0), _c('div', {
    ref: "chartRef",
    staticClass: "chart"
  })]), _c('div', {
    staticClass: "token-table"
  }, [_c('div', {
    staticClass: "token-table__title"
  }, [_vm._v(_vm._s(_vm.$lang("Transactions")))]), _c('div', {
    staticClass: "token-table-main"
  }, [_c('div', {
    staticClass: "token-table-head"
  }, [_c('span', {
    staticClass: "hover b",
    on: {
      "click": function ($event) {
        return _vm.onTradeSort('created_time');
      }
    }
  }, [_vm._v("Time "), _c('i')]), _c('span', {
    staticClass: "x hover",
    class: _vm.tradeListPage.sort === 'type' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTradeSort('type');
      }
    }
  }, [_vm._v("Type "), _c('i')]), _c('span', {
    on: {
      "click": function ($event) {
        return _vm.onTradeSort('ether_amount');
      }
    }
  }, [_vm._v("USD")]), _c('span', {
    staticClass: "hover",
    class: _vm.tradeListPage.sort === 'token_amount' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTradeSort('token_amount');
      }
    }
  }, [_vm._v("TOKEN "), _c('i')]), _c('span', {
    staticClass: "am hover",
    class: _vm.tradeListPage.sort === 'ether_amount' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onTradeSort('ether_amount');
      }
    }
  }, [_vm._v(_vm._s(_vm.web3Wallet.symbol) + " "), _c('i')]), !_vm.isMobile ? _c('span', [_vm._v("Address ")]) : _vm._e(), !_vm.isMobile ? _c('span', [_vm._v("Txn")]) : _vm._e()]), _c('div', {
    staticClass: "token-table-list"
  }, [_vm.isDetailLoading ? _vm._l(4, function (item, index) {
    return _c('div', {
      staticClass: "token-table-item"
    });
  }) : _vm._l(_vm.tradeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "token-table-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item.transaction_hash);
        }
      }
    }, [_c('span', {
      staticClass: "b"
    }, [_vm._v(_vm._s(item.created_time ? `${item.u_created_time} ago` : "--"))]), _c('span', {
      staticClass: "x",
      class: [item.type === 'sell' && 'sell', item.type === 'buy' && 'buy']
    }, [_vm._v(_vm._s(item.type))]), _c('span', [_c('i', {
      domProps: {
        "innerHTML": _vm._s(_vm.fmt_pre(_vm.bigNumber(item.ether_usd).times(item.ether_amount)))
      }
    })]), _c('span', [_c('i', {
      domProps: {
        "innerHTML": _vm._s(_vm.fmt_pre(_vm.fmt_toPre(item.token_amount)))
      }
    })]), _c('span', {
      staticClass: "am"
    }, [!_vm.isMobile ? _c('img', {
      attrs: {
        "src": _vm.web3Wallet.icon,
        "alt": ""
      }
    }) : _vm._e(), _c('i', {
      domProps: {
        "innerHTML": _vm._s(_vm.fmt_pre(_vm.fmt_sc(item.ether_amount), !_vm.isMobile ? 5 : 2))
      }
    })]), !_vm.isMobile ? _c('span', {
      staticClass: "zh",
      attrs: {
        "title": item.trader
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onSkip(item.trader, 'address');
        }
      }
    }, [_vm._v(_vm._s(_vm.fmt_addr(item.trader, 10)))]) : _vm._e(), !_vm.isMobile ? _c('span', {
      staticClass: "zh"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-share"
      }
    })], 1) : _vm._e()]);
  })], 2)]), _vm.tradeList && _vm.tradeList.length > 0 && _vm.tradeListPage.total > _vm.tradeListPage.perPage ? [_c('m-page', {
    attrs: {
      "tag": "",
      "total": _vm.tradeListPage.total,
      "page-size": _vm.tradeListPage.perPage,
      "page": _vm.tradeListPage.page,
      "on-page-change": _vm.onTradeListPage
    }
  })] : _vm._e()], 2), _vm.isMobile ? [_c('div', {
    staticClass: "token-holders"
  }, [_c('div', {
    staticClass: "token-holders-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Holders")))]), _c('span', [_vm._v("%")])]), [!_vm.isDetailLoading ? _vm._l(_vm.holder, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "token-holders-table"
    }, [_c('span', {
      staticClass: "hover",
      attrs: {
        "title": item.owner
      },
      on: {
        "click": function ($event) {
          return _vm.onSkip(_vm.tokenAddr, 'token', item.owner);
        }
      }
    }, [_vm._v(_vm._s(_vm._f("fmt_addr")(item.owner, 10))), _c('svg-icon', {
      attrs: {
        "name": "icon-share"
      }
    })], 1), _c('span', [_c('i', {
      domProps: {
        "innerHTML": _vm._s(item.ratio)
      }
    }), _vm._v("%")])]);
  }) : _vm._l(7, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "token-holders-table"
    });
  })], _vm.holder && _vm.holder.length > 0 && _vm.holderPage.total > _vm.holderPage.perPage ? [_c('m-page', {
    attrs: {
      "tag": " ",
      "total": _vm.holderPage.total,
      "page-size": _vm.holderPage.perPage,
      "page": _vm.holderPage.page,
      "on-page-change": _vm.onHolderPage
    }
  })] : _vm._e()], 2)] : _vm._e(), _c('div', {
    staticClass: "token-info"
  }, [_c('div', {
    staticClass: "token-fair"
  }, [_c('div', {
    staticClass: "token-fair__title"
  }, [_vm._v(_vm._s(_vm.$lang("Progress")))]), !_vm.tokenLaunched ? _c('div', {
    staticClass: "token-fair-main"
  }, [_c('div', {
    staticClass: "token-fair-date"
  }, [_c('span', {
    staticClass: "x"
  }, [_c('i', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail && _vm.detail.hasOwnProperty('web3_sold_token') ? `${_vm.fmt_pre(_vm.detail.web3_sold_token, 6)}%` : '')
    }
  })]), _c('span', [_vm._v(_vm._s(_vm.detail && _vm.detail["web3_pool_token"] ? _vm.fmt_pre(_vm.detail.web3_pool_token) : "") + " " + _vm._s(_vm.detail ? _vm.detail.symbol : "") + " Left")])]), _c('div', {
    staticClass: "token-fair-progress"
  }, [_c('p-progress', {
    attrs: {
      "progress": _vm.detail ? _vm.detail.web3_sold_token : 0
    }
  }), _c('div', {
    staticClass: "token-fair-progress__label"
  }, [_c('span', [_c('i', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail ? _vm.fmt_pre(_vm.detail.web3_pool_ether, 6) : '')
    }
  }), _vm._v(" " + _vm._s(_vm.web3Wallet.symbol) + " collected ")]), _c('span', [_c('i', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail ? _vm.fmt_pre(_vm.detail.web3_collect_eth) : '')
    }
  }), _vm._v(" " + _vm._s(_vm.web3Wallet.symbol) + " Left")])])], 1)]) : _vm._e(), _vm.tokenLaunched ? _c('div', {
    staticClass: "token-fair-main"
  }, [_c('div', {
    staticClass: "token-fair-date"
  }, [_c('span', {
    staticClass: "x"
  }, [_c('i', {
    domProps: {
      "innerHTML": _vm._s('100%')
    }
  })]), _c('span', [_vm._v(_vm._s(_vm.maxEther) + " " + _vm._s(_vm.web3Wallet.symbol) + " collected")])]), _c('div', {
    staticClass: "token-fair-progress"
  }, [_c('p-progress', {
    attrs: {
      "progress": "100"
    }
  })], 1), !_vm.uniswapV3 ? _c('div', {
    staticClass: "token-buy"
  }, [_c('div', {
    staticClass: "token-btn btn",
    on: {
      "click": _vm.goTrade
    }
  }, [_c('span', [_vm._v("Go to Trade")])])]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "token-menu",
    class: _vm.tokenLaunched && 'tokenLaunched'
  }, [_c('div', {
    staticClass: "token-menu-item price"
  }, [_c('div', {
    staticClass: "token-munu-item__label"
  }, [_vm._v(_vm._s(_vm.$lang("Price")))]), _c('div', {
    staticClass: "token-munu-item__value"
  }, [_c('span', [_c('i', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail ? _vm.fmt_pre(Number(_vm.detail.pool_price).toFixed(18), 4) : '')
    }
  }), _vm._v(" " + _vm._s(_vm.web3Wallet.symbol))])])]), _c('div', {
    staticClass: "token-menu-item mc"
  }, [_c('div', {
    staticClass: "token-munu-item__label"
  }, [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('div', {
    staticClass: "token-munu-item__value"
  }, [_c('span', [_vm._v("$ " + _vm._s(_vm.detail ? _vm.fmt_pre(_vm.detail.u_marketCap, Number(_vm.detail.u_marketCap) < 1 ? 6 : 0) : ""))])])]), _c('div', {
    staticClass: "token-menu-item vl"
  }, [_c('div', {
    staticClass: "token-munu-item__label"
  }, [_vm._v(_vm._s(_vm.$lang("Virtual Liquidity")))]), _c('div', {
    staticClass: "token-munu-item__value"
  }, [_c('span', [_vm._v("$ " + _vm._s(_vm.detail ? _vm.fmt_pre(_vm.detail.u_laquidity) : ""))])])]), _c('div', {
    staticClass: "token-menu-item vol"
  }, [_c('div', {
    staticClass: "token-munu-item__label"
  }, [_vm._v(_vm._s(_vm.$lang("24h volume")))]), _c('div', {
    staticClass: "token-munu-item__value"
  }, [_c('span', [_vm._v("$ " + _vm._s(_vm.detail ? _vm.detail.u_priceGain24hUsdt : ""))])])])]), [!_vm.tokenLaunched || _vm.uniswapV3 ? _c('div', {
    staticClass: "token-buy"
  }, [_c('div', {
    staticClass: "token-tab"
  }, [_c('p-tab', {
    attrs: {
      "tab": _vm.tab,
      "selectTab": _vm.selectTab,
      "width": "100%",
      "tabActiveColor": "#836ef9"
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "token-switch"
  }, [_c('div', {
    staticClass: "token-switch__title hover"
  }, [_c('div', {
    staticClass: "btn-setting hover",
    on: {
      "click": _vm.onShowSetting
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "setting"
    }
  }), _vm._v(_vm._s(_vm.$lang("Slippage")) + " " + _vm._s(_vm.slippage) + "%")], 1)]), _c('div', {
    staticClass: "token-switch-input",
    class: _vm.isBuyOrSellError && 'active'
  }, [_c('div', {
    staticClass: "token-switch-info"
  }, [_c('div', {
    staticClass: "token-switch-icon"
  }, [_c('div', {
    staticClass: "token-switch__img"
  }, [!_vm.isDetailLoading ? [_vm.selectTab === 'sell' && _vm.detail && _vm.detail.icon ? _c('img', {
    attrs: {
      "src": _vm.detail.icon,
      "alt": ""
    }
  }) : _vm._e(), _vm.selectTab === 'buy' && _vm.detail && _vm.web3Wallet.icon ? _c('img', {
    attrs: {
      "src": _vm.web3Wallet.icon,
      "alt": ""
    }
  }) : _vm._e()] : _vm._e(), _vm.isDetailLoading || _vm.detail && !_vm.detail.icon ? _c('m-img-empty') : _vm._e()], 2), _vm.selectTab === 'sell' ? _c('i', [_vm._v(_vm._s(_vm.detail ? _vm.detail.name : ""))]) : _c('i', [_vm._v(_vm._s(_vm.web3Wallet.symbol))])]), _c('div', {
    staticClass: "token-swich-input-main"
  }, [_vm.selectTab === 'buy' ? [_vm.web3Data.balance || !_vm.isWallet ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.switchNum,
      expression: "switchNum"
    }],
    class: _vm.isBuyOrSellError && 'active',
    attrs: {
      "type": "number",
      "placeholder": 0
    },
    domProps: {
      "value": _vm.switchNum
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.switchNum = $event.target.value;
      }, _vm.switchNumInput]
    }
  }) : _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  })] : _vm.selectTab === 'sell' ? [_vm.tokenBalance !== null || !_vm.isWallet ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.switchNum,
      expression: "switchNum"
    }],
    class: _vm.isBuyOrSellError && 'active',
    attrs: {
      "type": "number",
      "placeholder": 0
    },
    domProps: {
      "value": _vm.switchNum
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.switchNum = $event.target.value;
      }, _vm.switchNumInput]
    }
  }) : _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  })] : _vm._e()], 2)]), _c('div', {
    staticClass: "token-switch__balance"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Balance")) + ": "), _vm.web3Data.balance ? _c('i', [_vm._v(_vm._s(_vm.selectTab === "buy" ? _vm.web3Data.balance ? _vm.fmt_pre(_vm.web3Data.balance.formatted, 5) : "" : _vm.tokenBalance ? _vm.fmt_th(_vm.tokenBalance, 2) : ""))]) : _c('i', [_vm._v("0")]), _vm._v(" " + _vm._s(_vm.selectTab === "buy" ? _vm.web3Wallet.symbol : _vm.detail ? `${_vm.detail.symbol}` : "") + " ")])])]), _c('div', {
    staticClass: "token-switch-tab"
  }, [_vm.selectTab == 'buy' ? _vm._l(_vm.buyTab[_vm.web3Wallet.netId], function (item) {
    return _c('span', {
      staticClass: "hover",
      on: {
        "click": function ($event) {
          return _vm.switchTab(item);
        }
      }
    }, [_vm._v(_vm._s(item) + " " + _vm._s(_vm.web3Wallet.symbol))]);
  }) : _vm.selectTab == 'sell' ? _vm._l([0.1, 0.2, 0.5, 1], function (item) {
    return _c('span', {
      staticClass: "hover",
      on: {
        "click": function ($event) {
          return _vm.switchTab(item);
        }
      }
    }, [_vm._v(_vm._s(item * 100) + "%")]);
  }) : _vm._e()], 2), _vm.buyRefundNotice ? _c('div', {
    staticClass: "token-switch-refund"
  }, [_vm._v(_vm._s(_vm.buyRefundNotice))]) : _vm._e(), _vm.switchNumInfo ? _c('div', {
    staticClass: "token-switch-mes"
  }, [_vm._v(_vm._s(_vm.$lang("You will receive a minimum of ")) + " "), _c('i', {
    domProps: {
      "innerHTML": _vm._s(_vm.switchNumInfo)
    }
  }), _vm._v(" " + _vm._s(_vm.detail ? _vm.selectTab == "buy" ? `${_vm.detail.symbol}` : _vm.web3Wallet.symbol : ""))]) : _vm._e(), [_vm.isConnect !== 'connected' ? _c('div', {
    staticClass: "token-btn btn",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm.btnWalletLoading ? _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  }) : [_c('span', [_vm._v(_vm._s(_vm.$lang("Connect Wallet")))])]], 2) : _vm.isBuyOrSellError ? _c('div', {
    staticClass: "token-btn btn error"
  }, [_vm._v(_vm._s(_vm.isBuyOrSellError))]) : _vm.selectTab === 'buy' && _vm.web3Data.balance ? _c('div', {
    staticClass: "token-btn btn",
    on: {
      "click": _vm.onBuyEther
    }
  }, [_vm.isBtnBuyTokenLoading ? _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  }) : [_c('span', [_vm._v("Buy with " + _vm._s(_vm.web3Wallet.symbol))])]], 2) : _vm.selectTab === 'sell' && _vm.tokenBalance !== null ? _c('div', {
    staticClass: "token-btn btn",
    on: {
      "click": _vm.onSellToken
    }
  }, [_vm.isBtnSellTokenLoading ? _c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  }) : [_c('span', [_vm._v("Sell " + _vm._s(_vm.detail ? `${_vm.detail.symbol}` : ""))])]], 2) : _vm._e()]], 2) : _vm._e()], _vm.mLaunchShow && _vm.tokenAddr ? _c('div', {
    staticClass: "token-launch"
  }, [_c('m-launch', {
    ref: "marketingFee",
    attrs: {
      "tokenAddress": _vm.tokenAddr
    }
  })], 1) : _vm._e(), !_vm.isMobile ? [_c('div', {
    staticClass: "token-holders"
  }, [_c('div', {
    staticClass: "token-holders-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Holders")))]), _c('span', [_vm._v("%")])]), [!_vm.isDetailLoading ? _vm._l(_vm.holder, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "token-holders-table"
    }, [_c('span', {
      staticClass: "hover",
      attrs: {
        "title": item.owner
      },
      on: {
        "click": function ($event) {
          return _vm.onSkip(_vm.tokenAddr, 'token', item.owner);
        }
      }
    }, [_vm._v(_vm._s(_vm._f("fmt_addr")(item.owner, 10)) + " "), _c('svg-icon', {
      attrs: {
        "name": "icon-share"
      }
    })], 1), _c('span', [_c('i', {
      domProps: {
        "innerHTML": _vm._s(item.ratio)
      }
    }), _vm._v("%")])]);
  }) : _vm._l(7, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "token-holders-table"
    });
  })]], 2), _vm.holder && _vm.holder.length > 0 && _vm.holderPage.total > _vm.holderPage.perPage ? [_c('m-page', {
    attrs: {
      "tag": " ",
      "total": _vm.holderPage.total,
      "page-size": _vm.holderPage.perPage,
      "page": _vm.holderPage.page,
      "on-page-change": _vm.onHolderPage
    }
  })] : _vm._e()] : _vm._e()], 2)], 2)]), _c('pop-slippage', {
    attrs: {
      "show": _vm.popSlippageShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popSlippageShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };